// Tabla de subscribers de un magnet + CSV export.

import { downloadCSV, subscribersToCSV } from '../api';
import { useSubscribers } from '../hooks/useLeadMagnets';

interface Props {
  magnetId: number | null;
  magnetSlug?: string;
}

export function SubscriberTable({ magnetId, magnetSlug }: Props) {
  const { data, loading, error, refetch } = useSubscribers(magnetId, {
    limit: 500,
  });

  if (magnetId == null) {
    return (
      <div className="p-4 text-sm text-muted-foreground">
        Selecciona un magnet para ver sus subscribers.
      </div>
    );
  }
  if (loading && !data) {
    return <div className="p-4 text-sm text-muted-foreground">Cargando subscribers…</div>;
  }
  if (error) {
    return (
      <div className="p-4 text-sm text-destructive">
        Error: {error} · <button onClick={refetch} className="underline">Reintentar</button>
      </div>
    );
  }
  if (!data || data.items.length === 0) {
    return (
      <div className="p-4 text-sm text-muted-foreground">
        Sin subscribers todavía. Comparte la landing pública para empezar a capturar.
      </div>
    );
  }

  const onExport = () => {
    const csv = subscribersToCSV(data.items);
    downloadCSV(`subscribers-${magnetSlug || magnetId}.csv`, csv);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between px-3">
        <span className="text-xs text-muted-foreground">Total: {data.count}</span>
        <button
          onClick={onExport}
          className="px-3 py-1 text-xs border rounded hover:bg-muted"
        >
          Exportar CSV
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th className="px-3 py-2">Email</th>
              <th className="px-3 py-2">Nombre</th>
              <th className="px-3 py-2">Capturado</th>
              <th className="px-3 py-2">Consentimiento</th>
              <th className="px-3 py-2">Baja</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((s) => (
              <tr key={s.id} className="border-b hover:bg-muted">
                <td className="px-3 py-2 font-mono text-xs">{s.email}</td>
                <td className="px-3 py-2">{s.name || '—'}</td>
                <td className="px-3 py-2 text-xs text-muted-foreground">
                  {new Date(s.captured_at).toLocaleString()}
                </td>
                <td className="px-3 py-2 text-xs text-muted-foreground">
                  {s.consent_at ? new Date(s.consent_at).toLocaleString() : '—'}
                </td>
                <td className="px-3 py-2 text-xs text-muted-foreground">
                  {s.unsubscribed_at
                    ? new Date(s.unsubscribed_at).toLocaleString()
                    : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
